import { Box, Tab, Tabs, Tooltip } from '@mui/material';
import { useState } from 'react';
import TypographyFields from './Fields/TypographyFields';
import { useTranslation } from 'react-i18next';

function TabLabel({ label, tooltip }) {
    return (
        <Tooltip title={tooltip} placement="top">
            <span>{label}</span>
        </Tooltip>
    );
}

function Headings() {
    const { t } = useTranslation();
    const [heading, setHeading] = useState('paragraph');

    return (
        <>
            <Tabs
                variant="fullWidth"
                value={heading}
                onChange={(e, value) => setHeading(value)}
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    mb: 2,
                    '& .MuiButtonBase-root': {
                        minWidth: 'unset',
                    },
                }}
            >
                <Tab
                    value="paragraph"
                    label={
                        <TabLabel
                            label={t('Text')}
                            tooltip={t('Text Styles')}
                        />
                    }
                />
                <Tab
                    value="heading-one"
                    label={
                        <TabLabel
                            label={t('H1')}
                            tooltip={t('Heading 1 Styles')}
                        />
                    }
                />
                <Tab
                    value="heading-two"
                    label={
                        <TabLabel
                            label={t('H2')}
                            tooltip={t('Heading 2 Styles')}
                        />
                    }
                />
                <Tab
                    value="heading-three"
                    label={
                        <TabLabel
                            label={t('H3')}
                            tooltip={t('Heading 3 Styles')}
                        />
                    }
                />
                <Tab
                    value="heading-four"
                    label={
                        <TabLabel
                            label={t('H4')}
                            tooltip={t('Heading 4 Styles')}
                        />
                    }
                />
            </Tabs>
            <TypographyFields globalProperty={heading} />
        </>
    );
}

export default Headings;
